export function ToggleSwitch({
  checked,
  onChange,
  accentColor,
}: {
  checked: boolean;
  onChange: (v: boolean) => void;
  accentColor?: string;
}) {
  return (
    <button
      onClick={() => onChange(!checked)}
      className="relative shrink-0 transition-colors duration-200"
      style={{
        width: 64,
        height: 28,
        borderRadius: 14,
        backgroundColor: checked ? (accentColor || 'var(--t-toggle-on)') : 'var(--t-toggle-off)',
      }}
    >
      <div
        className="absolute top-[2px] bg-white shadow"
        style={{
          width: 39,
          height: 24,
          borderRadius: 13,
          transform: checked ? 'translateX(23px)' : 'translateX(2px)',
          transition: 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
        }}
      />
    </button>
  );
}
